import store from './store'
import auth from './utils/auth'

export default {
  authWithNoFirstLogin(to, from, next) {
    if (to.name !== 'Login' && !store.state.auth.isAuthenticated)
      next({ name: 'Login' })
    else next()
  },
  auth(to, from, next) {
    if (to.name !== 'Login' && !store.state.auth.isAuthenticated) {
      next({ name: 'Login' })
    } else {
      if (store.state.auth.user.novaSenhaLogin ?? false) {
        next({ name: 'SetPasswordLogin' })
      } else {
        next()
      }
    }
  },
  onlyNoAuthenticated(to, from, next) {
    if (store.state.auth.isAuthenticated) next({ name: 'Home' })
    else next()
  },
  admin(to, from, next) {
    if (!store.state.auth.isAuthenticated) {
      next({ name: 'Login' })
    } else if (!auth.isAdmin()) {
      next({ name: 'Home' })
    } else {
      next()
    }
  },
  isRole(role) {
    return (to, from, next) => {
      if (auth.isAdmin()) {
        next()
      } else if (!store.state.auth.isAuthenticated) {
        next({ name: 'Login' })
      } else if (!auth.hasRole(role)) {
        next({ name: 'Home' })
      } else {
        next()
      }
    }
  },
  hasOneRole(roles) {
    return (to, from, next) => {
      if (auth.isAdmin()) {
        next()
      } else if (!store.state.auth.isAuthenticated) {
        next({ name: 'Login' })
      } else if (!roles.some((role) => auth.hasRole(role))) {
        next({ name: 'Home' })
      } else {
        next()
      }
    }
  },
}
